import React from "react";
import WebsiteV3 from "./components/WebsiteV3";

function App() {
  return <WebsiteV3 />;
}

export default App;
